import {
  ionNumberMaxLength,
  roleNameMaxLength,
  teamNameMaxLength,
  groupComponentsMinLength,
} from '../../components/Teams/team-validation';
import { dayShiftHoursConstraint } from '../../components/Teams/TeamEditor/util';

export const errorMessage = {
  multipleFormErrors: (messages: readonly string[]) =>
    `Errors: ${messages.join(', ')}, please review the form.`,
  dayShiftOutsideBoundary: `Shift period must be within ${dayShiftHoursConstraint.min} and ${dayShiftHoursConstraint.max} hours.`,
  dayShiftPeriodNotGiven: 'Day Shift period is required',
  nightShiftPeriodNotGiven: 'Night Shift period is required',
  environmentVariableNotDefined: (variable: string) =>
    `The [${variable}] environment variable must be defined.`,
  endTimeMissing: 'End time is missing',
  errorBoundaryMessage: 'Uh oh! Something went wrong.',
  errorBoundaryMessageDescription: 'Please refresh.',
  incidentNameDuplicated: 'Incident Event Name has been used before.',
  incidentNameNotGiven: 'Incident Event Name is required',
  incidentNameTooLong: `Incident Event Name cannot be greater than ${teamNameMaxLength} characters.`,
  incidentNameTooShort: `Incident Event Name cannot be less than ${groupComponentsMinLength} character.`,
  incidentNameSpecialCharacters: `Incident Event Name cannot contain double quotes or backslashes`,
  incidentEventHasWhitespaceOnEnds:
    'Incident Event Name cannot start or end with a space',
  ionNotGiven: 'Internal Order Number (ION) is required',
  ionTooLong: `Internal Order Number (ION) cannot be greater than ${ionNumberMaxLength} characters.`,
  ionTooShort: `Internal Order Number (ION) cannot be less than ${groupComponentsMinLength} character.`,
  ionSpecialCharacters: `Internal Order Number (ION) cannot contain double quotes or backslashes`,
  ionHasWhitespaceOnEnds:
    'Internal Order Number (ION) cannot start or end with a space',
  loginError: 'Login Error: Not a P&RAS registered user',
  loginErrorDescription: `It looks like you haven't been assigned to the user group specified \
    by the Director of State Operations and cannot access the application. \
    If this is in error, please contact the State Duty Operations Officer at \
    (02) 8741 5400 or via email at state.ops@rfs.nsw.gov.au. If you belong to this \
    group and still can't access PRAS, please call the NSW RFS Service Desk on 1800 005 123.`,
  permissionNotGranted: `You don't have permission to perform this action.`,
  roleAlreadyExists: 'Role already exists',
  roleIsRequired: 'Role is required',
  roleNameTooLong: `Role name cannot be longer than ${roleNameMaxLength} characters.`,
  rolesNotUnique: 'Roles must be unique',
  rostersNotFound: 'No rosters found',
  startTimeAfterEndTime: 'Start time is after end time',
  startTimeMissing: 'Start time is missing',
  teamNotFound: 'Team not found',
  teamInformationNotFound: 'Failed to retrieve team information.',
  teamTypeNotGiven: 'Team Type is required',
  genericDataConstraintViolation: 'Data is invalid, please check and retry.',
  noPrasAdminRole:
    'No PRAS Admin role found in SOC, please contact State Duty Operations Officer at (02) 8741 5400.',
  feedbackAttachmentsExceedMaximum: 'Images exceed maximum size (2.2MB)',
};

export const successMessage = {
  roleAdded: 'Role Added',
  roleDeactivated: 'Role Deactivated',
  roleReactivated: 'Role Reactivated',
  roleUpdated: 'Role Updated',
  shiftCreated: 'Shift Created',
  shiftRemoved: 'Shift Removed',
  shiftUpdated: 'Shift Updated',
  teamCreated: 'Team Created',
  teamDeleted: 'Team Deleted',
  teamArchived: 'Team Archived',
  teamUpdated: 'Team Updated',
  teamReactivated: 'Team Reactivated',
  teamRoleAssignmentDeleted: 'Team Role Assignment Deleted',
  userRoleAssignmentSaved: 'User Role Assignment Saved',
};
